<template>
  <div id="new-invest-page">
    <div class="detail-title">
      <div class="title-left-col medium-white-20">{{ propInfo.name }}</div>
      <div class="title-right-col">
        <tr>
          <td style="padding: 0px 25px;">
            <img src="@/assets/icons/investor-icon.svg" alt />
            <span class="medium-white-16">
              นักลงทุน
              <span class="medium-white-12">(สูงสุด)*</span>
              {{ propInfo.maxInvestor }} คน
            </span>
          </td>
          <td style="border-left: 1px solid #FFFFFF; padding-left: 25px;">
            <span class="medium-white-16">ราคาประเมิน: {{propPrice}} บาท</span>
          </td>
        </tr>
      </div>
    </div>
    <div class="invest-section">
      <div class="container">
        <div class="row invest-no-gutters">
          <div class="col-lg-8 col-md-12">
            <PropImgCarousel :propImages="propImg"></PropImgCarousel>
          </div>
          <div class="new-invest-box col-lg-4 col-md-12">
            <div class="invest-section-header medium-white-16">สร้างการร่วมลงทุน</div>
            <div class="medium-16" style="padding:20px">{{ propInfo.name }}</div>
            <div class="prop-invest-table">
              <table class="container">
                <tbody>
                  <tr>
                    <td>
                      <div class="light-14">อัตราเช่าต่อปี</div>
                      <div class="regular-bold-20">{{propInfo.interestPercen}}%</div>
                    </td>
                    <td>
                      <div class="with-border-line"></div>
                      <div class="light-14">เรตติ้ง</div>
                      <div class="regular-bold-20">
                        {{propInfo.rating}}/
                        <span class="regular-bold-16">10</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="prop-invest-amt">
              <div class="container">
                <div class="light-14">ราคาขั้นต่ำ</div>
                <div class="regular-bold-24">
                  {{minInvestAmount}}
                  <span class="regular-bold-14">บาท</span>
                </div>
              </div>
            </div>
            <div class="prop-invest-btn">
              <vs-button
                color="#533D67"
                class="medium-white-18 new-invest-btn"
                @click="scrollDown()"
              >สร้างการร่วมลงทุน</vs-button>
            </div>
            <div class="prop-ref medium-16" @click="openPropWeb()">เยี่ยมชมเว็บไซต์โครงการ</div>
          </div>
        </div>
      </div>
    </div>
    <div class="detail-section">
      <div class="container">
        <div class="detail-section-header medium-16">รายละเอียดโครงการ</div>
        <div class="container border-bottom-line" style="margin-top:25px;">
          <div class="row">
            <div class="col-md-6">
              <div class="detail-container">
                <div class="detail-table-header medium-16">ข้อมูลโครงการ</div>
                <div class="light-14">ชื่อโครงการ</div>
                <div class="medium-16 margin-bottom">{{propInfo.name}}</div>
                <div class="light-14">เจ้าของโครงการ</div>
                <div class="medium-16 margin-bottom">{{propInfo.developer}}</div>
                <div class="light-14">ประเภทโครงการ</div>
                <div class="medium-16 margin-bottom">{{propertyType}}</div>
                <div class="light-14">ราคา</div>
                <div class="medium-16 margin-bottom">
                  {{propPrice}}
                  <span class="regular-14">บาท</span>
                </div>
                <div class="light-14">ราคาต่อตารางเมตร</div>
                <div class="medium-16 margin-bottom">
                  {{pricePerArea}}
                  <span class="regular-14">บาท</span>
                </div>
                <div class="light-14">ขนาดพื้นที่</div>
                <div class="medium-16 margin-bottom">
                  {{propInfo.propScale}}
                  <span class="regular-14">ตร.ม.</span>
                </div>
                <div class="light-14">ลงประกาศเมื่อ</div>
                <div class="medium-16 margin-bottom">{{postDate}}</div>
                <div class="light-14">ปีที่แล้วเสร็จ</div>
                <div class="medium-16 margin-bottom">{{propInfo.propFinishDate}}</div>
              </div>
            </div>
            <div class="col-md-6 with-left-line">
              <div class="detail-container">
                <div class="detail-table-header medium-16">ข้อมูลการลงทุน</div>
                <div class="light-14">อัตราผลตอบแทน (ต่อปี)</div>
                <div class="medium-16 margin-bottom">{{propInfo.interestPercen}}%</div>
                <div class="medium-16 margin-bottom">ปรับรายละเอียดด้านล่างเพื่อคำนวณผลตอบแทน</div>
                <div class="row no-gutters margin-bottom">
                  <div class="col-5 label-center">
                    <div class="light-14">ราคา</div>
                  </div>
                  <div class="col-7">
                    <div class="medium-16">
                      {{propPrice}}
                      <span class="light-14" style="float:right">บาท</span>
                    </div>
                  </div>
                </div>
                <div class="row no-gutters margin-bottom">
                  <div class="col-5 label-center line-height">
                    <div class="light-14">จำนวนผู้ร่วมลงทุน(คน)</div>
                  </div>
                  <div class="col-7 vs-select-custom">
                    <vs-select
                      placeholder="โปรดเลือกจำนวนผู้ร่วมลงทุน"
                      v-model="selectMaxInvestorNum"
                    >
                      <vs-option
                        v-for="i in selectorRange"
                        v-bind:key="i"
                        :label="i"
                        :value="i"
                      >{{i}}</vs-option>
                    </vs-select>
                  </div>
                </div>
                <div class="row no-gutters margin-bottom">
                  <div class="col-5 label-center line-height">
                    <div class="light-14">ราคาต่อหน่วยการลงทุน</div>
                  </div>
                  <div class="col-7">
                    <div class>
                      <span class="medium-16">{{investAmtPerUnit}}</span>
                      <span class="light-14" style="float:right">บาท</span>
                    </div>
                  </div>
                </div>
                <div class="row no-gutters margin-bottom">
                  <div class="col-5 label-center line-height">
                    <div class="light-14">ระยะเวลา</div>
                  </div>
                  <div class="col-7">
                    <div class="computed-box">
                      <input class="computed-var-input regular-16" v-model="year" />
                      <span class="light-14" style="float:right">ปี</span>
                    </div>
                  </div>
                </div>
                <div class="row no-gutters margin-bottom">
                  <div class="col-5 label-center line-height">
                    <div class="light-14">อัตราผลตอบแทน</div>
                  </div>
                  <div class="col-7">
                    <div class="computed-box">
                      <input class="computed-var-input regular-16" v-model="benefitInterest" />
                      <span class="light-14" style="float:right">%</span>
                    </div>
                  </div>
                </div>
                <div class="row no-gutters line-height" style="margin-top:25px">
                  <div class="col-6 label-center">
                    <div class="medium-16">ผลตอบแทนที่คาดว่าจะได้รับ</div>
                  </div>
                  <div class="col-6">
                    <div class="medium-16">
                      {{estimateReturn}}
                      <span class="light-14">บาท (โดยประมาณ)</span>
                    </div>
                  </div>
                </div>
                <div class="row no-gutters line-height">
                  <div class="col-6 label-center">
                    <div class="medium-16">สัดส่วนกรรมสิทธิ์</div>
                  </div>
                  <div class="col-6">
                    <div class="medium-16">{{ownershipPercentage}}%</div>
                  </div>
                </div>
                <div class="row no-gutters line-height margin-bottom">
                  <div
                    class="regular-red-12"
                  >*หมายเหตุ การคำนวณข้างต้นเป็นเพียงการจำลองเพื่อคาดการณ์ผลตอบแทนล่วงหน้า ไม่ได้เป็นการการันตีผลตอบแทนที่เกิดขึ้นจากแพลตฟอร์มแต่อย่างใด ผลตอบแทนที่เกิดขึ้นจริง อาจมีการเปลี่ยนแปลงเนื่องจากปัจจัยต่าง ๆ</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container border-bottom-line">
        <div class="description-box">
          <div class="medium-16">รายละเอียดเพิ่มเติม</div>
          <div class="light-16 margin-top">{{propInfo.detail}}</div>
        </div>
      </div>
      <div class="container border-bottom-line">
        <div class="description-box">
          <div class="medium-16">สื่งอำนวยความสะดวก</div>
          <div class="row margin-top" v-if="propInfo.properties !== undefined">
            <div class="col-md-6">
              <img class="check-icon" :src="facilitiesCheck(propInfo.properties.lobby)" />
              <div class="facility-item regular-16 margin-bottom">Lobby, Mail Box</div>
              <img class="check-icon" :src="facilitiesCheck(propInfo.properties.park)" />
              <div class="facility-item regular-16 margin-bottom">สวนสาธารณะ</div>
              <img class="check-icon" :src="facilitiesCheck(propInfo.properties.pool)" />
              <div class="facility-item regular-16 margin-bottom">สระว่าย</div>
              <img class="check-icon" :src="facilitiesCheck(propInfo.properties.fitness)" />
              <div class="facility-item regular-16 margin-bottom">ฟิตเนส</div>
              <img class="check-icon" :src="facilitiesCheck(propInfo.properties.sport_field)" />
              <div class="facility-item regular-16 margin-bottom">สนามกีฬากลางแจ้ง</div>
            </div>
            <div class="col-md-6">
              <img class="check-icon" :src="facilitiesCheck(propInfo.properties.library)" />
              <div class="facility-item regular-16 margin-bottom">ห้องอ่านหนังสือ</div>
              <img class="check-icon" :src="facilitiesCheck(propInfo.properties.keyCard)" />
              <div class="facility-item regular-16 margin-bottom">ประตู Key Card</div>
              <img class="check-icon" :src="facilitiesCheck(propInfo.properties.CCTV)" />
              <div class="facility-item regular-16 margin-bottom">กล้อง CCTV รอบโครงการ</div>
              <img class="check-icon" :src="facilitiesCheck(propInfo.properties.security)" />
              <div class="facility-item regular-16 margin-bottom">ระบบรักษาความปลอดภัยตลอด 24 ชม</div>
            </div>
          </div>
        </div>
      </div>
      <div class="container border-bottom-line">
        <div class="description-box">
          <div class="medium-16 margin-bottom">สถานที่ใกล้เคียง</div>
          <div class="row margin-top" v-if="propInfo.nearestProp !== undefined">
            <div class="col-md-6">
              <ul class="location-list">
                <li
                  class="margin-bottom"
                  v-for="(location, index) in propInfo.nearestProp.slice(0, (this.propInfo.nearestProp.length / 2)+1)"
                  :key="index"
                >
                  <span class="regular-16">{{location.name}}</span>
                </li>
              </ul>
            </div>
            <div class="col-md-6">
              <ul class="location-list">
                <li
                  class="margin-bottom"
                  v-for="(location, index) in propInfo.nearestProp.slice((this.propInfo.nearestProp.length / 2)+1)"
                  :key="index"
                >
                  <span class="regular-16">{{location.name}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="container border-bottom-line">
        <div class="description-box">
          <div class="medium-16 margin-bottom">ทำเลที่ตั้ง</div>
          <div class="map-container">
            <PropMap v-if="createMap" :key="mapKey" :mapCenter="mapCenter" :markers="markers"></PropMap>
          </div>
        </div>
      </div>
      <div class="container margin-top margin-bottom" ref="newinvestform">
        <div class="new-invest-header medium-white-16 margin-bottom">สร้างการร่วมลงทุน</div>
        <div class="container new-invest-formbox">
          <div class="new-invest-form row border-bottom-line">
            <div class="col-md-6">
              <div class="row no-gutters">
                <div class="col-5 label-center">
                  <div class="light-16">ชื่อโครงการ</div>
                </div>
                <div class="col-7 label-center line-height">
                  <div class="medium-16">{{propInfo.name}}</div>
                </div>
              </div>
              <div class="row no-gutters">
                <div class="col-5 label-center">
                  <div class="light-16">ประเภทโครงการ</div>
                </div>
                <div class="col-7 label-center line-height">
                  <div class="medium-16">{{propertyType}}</div>
                </div>
              </div>
              <div class="row no-gutters">
                <div class="col-5 label-center">
                  <div class="light-16">ราคา</div>
                </div>
                <div class="col-7 label-center line-height">
                  <div class="medium-16">
                    {{propPrice}}
                    <span class="regular-14">บาท</span>
                  </div>
                </div>
              </div>
              <div class="row no-gutters">
                <div class="col-5 label-center">
                  <div class="light-16">ขนาดพื้นที่</div>
                </div>
                <div class="col-7 label-center line-height">
                  <div class="medium-16">
                    {{propInfo.propScale}}
                    <span class="regular-14">ตร.ม.</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row no-gutters">
                <div class="col-5 label-center">
                  <div class="light-16">จำนวนผู้ร่วมลงทุน (คน)</div>
                </div>
                <div class="col-7 vs-select-custom">
                  <vs-select
                    placeholder="โปรดเลือกจำนวนผู้ร่วมลงทุน"
                    v-model="selectMaxInvestorNum"
                  >
                    <vs-option v-for="i in selectorRange" v-bind:key="i" :label="i" :value="i">{{i}}</vs-option>
                  </vs-select>
                </div>
              </div>
              <div class="row no-gutters">
                <div class="col-5 label-center line-height">
                  <div class="light-16">ราคาต่อหน่วยการลงทุน</div>
                </div>
                <div class="col-7 line-height">
                  <span class="medium-16">{{investAmtPerUnit}}</span>
                  <span class="light-14" style="float:right">บาท</span>
                </div>
              </div>
              <div class="row no-gutters">
                <div class="col-5 label-center line-height">
                  <div class="light-16">เงินมัดจำ</div>
                </div>
                <div class="col-7 line-height">
                  <span class="medium-16">5,000</span>
                  <span class="light-14" style="float:right">บาท</span>
                </div>
              </div>
              <div class="row no-gutters">
                <div class="line-height">
                  <div class="regular-red-16">*โปรโมชั่นพิเศษ สร้างการลงทุนวันนี้ ฟรี ค่ามัดจำ</div>
                </div>
              </div>
            </div>
          </div>
          <div class="new-invest-form row">
            <div class="container">
              <div class="medium-18 margin-bottom">แบบฟอร์มติดต่อกลับ</div>
              <div class="row no-gutters margin-bottom">
                <div class="col-2 label-center">
                  <div class="light-16">
                    ชื่อ
                    <span class="regular-red-16">*</span>
                  </div>
                </div>
                <div class="col-10">
                  <vs-input
                    class="contact-input-form"
                    v-model="name"
                    placeholder="ชื่อสำหรับติดต่อกลับ"
                  />
                </div>
              </div>
              <div class="row no-gutters margin-bottom">
                <div class="col-2 label-center">
                  <div class="light-16">
                    อีเมล
                    <span class="regular-red-16">*</span>
                  </div>
                </div>
                <div class="col-10">
                  <vs-input
                    class="contact-input-form"
                    v-model="email"
                    placeholder="อีเมลสำหรับติดต่อกลับ"
                  />
                </div>
              </div>
              <div class="row no-gutters margin-bottom">
                <div class="col-2 label-center">
                  <div class="light-16">เบอร์โทรศัพท์</div>
                </div>
                <div class="col-10">
                  <vs-input
                    class="contact-input-form"
                    v-model="telNo"
                    placeholder="เบอร์โทรศัพท์สำหรับติดต่อกลับ"
                  />
                </div>
              </div>
              <div class="row no-gutters contact-form-btn">
                <vs-button
                  color="#533D67"
                  class="medium-white-18 submit-contact-btn"
                  :disabled="isDisabled"
                  @click="submitContactForm()"
                >สร้างการร่วมลงทุน</vs-button>
              </div>
              <div style="text-align:center">
                <span
                  class="medium-blue-16"
                  @click="seeMoreDetail()"
                  style="cursor: pointer"
                >รายละเอียดเพิ่มเติม ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SuccessModal ref="successModal"></SuccessModal>
  </div>
</template>

<script>
import PropImgCarousel from '@/components/PropImgCarousel'
import SuccessModal from '@/components/SuccessModal'
import PropMap from '@/components/PropMap'
import { getPropertyInfo, submitNewInvest } from '@/firebase/firebase-transaction'
import formatDate from '@/util/formatDate'
import { numberWithCommas, numberWithOutCommas } from '@/util/numberComma'
import { PDF_FILE_URL } from '@/common/constant'
// import getDate from '@/util/getDate'
export default {
  name: 'PropertyNewInvestPage',
  components: {
    PropImgCarousel,
    SuccessModal,
    PropMap
  },
  data() {
    return {
      statusChecked: require('@/assets/icons/status-checked.svg'),
      statusUnchecked: require('@/assets/icons/status-unchecked.svg'),
      propImg: [],
      selectMaxInvestorNum: 2,
      year: 5,
      benefitInterest: 0,
      name: '',
      email: '',
      telNo: '',
      propId: '',
      propInfo: '',
      selectorRange: [2, 3, 4, 5, 6, 7, 8, 9, 10],
      markers: [
        {
          location: { lon: 13.729786, lat: 100.536461 },
          title: '',
          detail: ''
        }
      ],
      mapCenter: { lon: 13.729786, lat: 100.536461 },
      mapKey: 0,
      createMap: false
    }
  },
  computed: {
    investAmtPerUnit() {
      if (this.propInfo.propAmount !== undefined && this.propInfo.propAmount !== null) {
        return numberWithCommas((this.propInfo.propAmount / this.selectMaxInvestorNum).toFixed(2))
      } else {
        return ''
      }
    },
    ownershipPercentage() {
      return (100.0 / this.selectMaxInvestorNum).toFixed(6)
    },
    minInvestAmount() {
      if (this.propInfo.propAmount !== undefined && this.propInfo.propAmount !== null) {
        return numberWithCommas(this.propInfo.propAmount / this.propInfo.maxInvestor)
      } else {
        return ''
      }
    },
    pricePerArea() {
      return numberWithCommas((this.propInfo.propAmount / this.propInfo.propScale).toFixed(2))
    },
    postDate() {
      return formatDate(this.propInfo.postDate)
    },
    estimateReturn() {
      return numberWithCommas(
        ((this.benefitInterest / 100) * numberWithOutCommas(this.investAmtPerUnit) * this.year).toFixed(2)
      )
    },
    propPrice() {
      if (this.propInfo.propAmount !== undefined && this.propInfo.propAmount !== null) {
        return numberWithCommas(this.propInfo.propAmount)
      } else {
        return ''
      }
    },
    isDisabled() {
      if (this.name !== '' && this.email !== '') {
        return false
      } else {
        return true
      }
    },
    propertyType() {
      if (this.propInfo.propType !== undefined && this.propInfo.propType !== null) {
        if (this.propInfo.propType.toUpperCase() === 'CONDOMINIUM') {
          return 'คอนโดมิเนียม'
        } else if (this.propInfo.propType.toUpperCase() === 'HOUSE') {
          return 'บ้าน'
        } else {
          return ''
        }
      } else {
        return ''
      }
    }
  },
  methods: {
    range(max) {
      var list = []
      for (var i = 2; i <= max; i++) {
        list.push(i)
      }
      return list
    },
    facilitiesCheck(status) {
      if (status) {
        return this.statusChecked
      } else {
        return this.statusUnchecked
      }
    },
    scrollDown() {
      this.$refs.newinvestform.scrollIntoView()
    },
    showSuccessModal() {
      this.$refs.successModal.openModal()
    },
    openPropWeb() {
      window.open('' + this.propInfo.propWebsite)
    },
    seeMoreDetail() {
      window.open(PDF_FILE_URL)
    },
    async submitContactForm() {
      var date = new Date().getTime()
      var finishDate = date + 7776000000
      var res = await submitNewInvest(
        this.propId,
        date,
        numberWithOutCommas(this.investAmtPerUnit),
        0,
        this.selectMaxInvestorNum,
        this.name,
        this.email,
        this.telNo,
        finishDate
      )
      if (res != null) {
        this.showSuccessModal()
      }
      this.benefitInterest = 0
      this.name = ''
      this.email = ''
      this.telNo = ''
      this.propId = ''
    }
  },
  async created() {
    // console.log(this.$route.params)
    // this.propId = this.$route.params.propId
    this.propId = sessionStorage.getItem('propId')
    this.propInfo = await getPropertyInfo(this.propId)
    this.benefitInterest = this.propInfo.interestPercen
    this.propImg = JSON.parse(this.propInfo.prop_img).prop_img
    this.propInfo.properties = JSON.parse(this.propInfo.properties)
    this.propInfo.nearestProp = JSON.parse(this.propInfo.nearestProp).nearestProp
    this.selectorRange = this.range(this.propInfo.maxInvestor)
    this.markers = [
      {
        location: { lon: this.propInfo.lng, lat: this.propInfo.lat },
        title: this.propInfo.name,
        detail: ''
      }
    ]
    this.mapCenter = { lon: this.propInfo.lng, lat: this.propInfo.lat }
  },
  watch: {
    propInfo() {
      this.mapKey++
      this.createMap = true
    }
  }
}
</script>

<style scoped>
@import '../styles/PropertyDetailPage.css';
@import '../styles/PropertyBoxStyle.css';
</style>
